import React from 'react';
import { Publication } from '../../../components/HOC/HOCDecoratedComponents';

export const PublicationsList = props => {
        const { data, mode, guestMode } = props;
        return (
            <div className="list-achievements">
                { data.map((item) => {
                    item.numberButtons = 3;
                    return (
                        <div key={ item.id } className="item-wrapper">
                            <Publication componentData={ item } mode={ mode } guestMode={ guestMode } actionName="publicationsApiCall"/>
                        </div>
                    )
                })
                }
            </div>
        )
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/body/achievements/PublicationsList.js